<div *ngIf="!getButtonParams()" [ngSwitch]="buttonType">
  <p
    *ngSwitchCase="ButtonType.ACTIVE"
    class="rs-status rs-success rs-justify-center"
  >
    <i class="rs-status-icon" aria-hidden="true"></i>Active
  </p>

  <a
    *ngSwitchCase="ButtonType.ACTIVATE"
    (click)="activateDisneyPlus()"
    [class]="'rs-btn rs-btn-neg rs-maxw' + buttonClass"
    [disabled]="service.isLoadingState || service.isDisabledState"
    [ngClass]="{
      'rs-btn-waiting': isLoadingToken
    }"
    data-tms-event="button-click"
    data-tms-button-zone="tv options ordering"
    attr.data-tms-button-name="{{
      'tv.active.options.disneyplus.button.activate' | translate
    }}"
    target="_blank"
    data-cy="tvDisneyPlusActivateButton"
    >{{ "tv.active.options.disneyplus.button.activate" | translate }}
    <i class="icon-Target-Blank rs-margin-left1"
      ><span class="show-for-sr">{{
        "tv.active.options.disneyplus.button.screenReader.openNewWindow"
          | translate
      }}</span></i
    >
    <div *ngIf="isLoadingToken" class="rs-btn-waiting-dots"></div>
  </a>

  <a
    *ngSwitchCase="ButtonType.WATCH"
    [disabled]="service.isLoadingState || service.isDisabledState"
    href="{{ 'tv.active.options.disneyplus.button.watch.link' | translate }}"
    class="rs-btn rs-btn-neg rs-btn-nl-so"
    data-tms-event="button-click"
    data-tms-button-zone="tv options ordering"
    attr.data-tms-button-name="{{
      'tv.active.options.disneyplus.button.watch' | translate
    }}"
    target="_blank"
    data-cy="tvDisneyPlusWatchButton"
  >
    {{ "tv.active.options.disneyplus.button.watch" | translate }}
    <i class="icon-Target-Blank rs-margin-left1" title="Opens a new window">
      <span class="show-for-sr">{{
        "tv.active.options.disneyplus.button.screenReader.openNewWindow"
          | translate
      }}</span></i
    ></a
  >
</div>

<ng-container *ngIf="getButtonParams() as buttonParams">
  <button
    [class]="buttonParams.class"
    [disabled]="buttonParams.disabled"
    (click)="buttonParams.click()"
  >
    <div *ngIf="service.isLoadingState" class="rs-btn-waiting-dots"></div>
    <span *ngIf="!service.isLoadingState"
      >{{ buttonParams.labelKey | translate }}
    </span>
    <i
      *ngIf="buttonParams.showRightIcon"
      class="rs-icon-btn-third rs-margin-left1"
      aria-hidden="true"
    ></i>
  </button>
</ng-container>

